import { render, staticRenderFns } from "./LocaleDropdown.vue?vue&type=template&id=474d8566&"
import script from "./LocaleDropdown.vue?vue&type=script&lang=js&"
export * from "./LocaleDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports